/**
 * Módulos que se ligam **por confeitaria**, não por ambiente.
 *
 * DIFERENÇA PARA `features.js`: aquelas são chaves de *build* — valem para
 * todo o ambiente, e servem para segurar um lançamento até ele estar pronto.
 * Estas são de *conta*: a feature está pronta, e quem decide se aparece é o
 * suporte, uma confeitaria de cada vez, sem novo deploy.
 *
 * A fonte é o `tenant` do AuthContext, que vem do backend. Chave ausente
 * significa desligado — e é por isso que as confeitarias que existem hoje
 * continuam vendo exatamente o que viam antes de o módulo existir.
 *
 * Esconder o botão não é controle de acesso: o portão de verdade é o
 * `before_request` em `backend/routes_etiquetas.py`. Aqui é só para a tela não
 * oferecer o que o servidor vai recusar.
 *
 * SEM IMPORTS de propósito. Este arquivo é lido por quase toda tela, e uma
 * dependência aqui viraria dependência delas todas — inclusive do teste, que
 * precisa poder exercitar a regra sem montar React nenhum.
 */

export const MODULO_ETIQUETAS = 'etiquetas';

/**
 * Tolera `tenant` nulo (boot, logout) e `modulos` ausente (tenant salvo no
 * storage por uma versão anterior do app — acontece em todo deploy).
 */
export function moduloLigado(tenant, nome) {
  if (!tenant || !nome) return false;
  return Boolean(tenant.modulos && tenant.modulos[nome]);
}
